import { z } from 'zod';

export const WarehouseFields = z.object({
  city: z.string(),
  agency_id: z.number(),
  name: z.string(),
  name_en: z.string(),
  zipcode: z.string(),
  address1: z.string(),
  address2: z.string(),
  principal_name: z.string(),
  phone: z.string(),
  memo: z.string(),
});

export const Warehouse = WarehouseFields.pick({
  city: true,
  agency_id: true,
  name: true,
  name_en: true,
  zipcode: true,
  address1: true,
  address2: true,
  principal_name: true,
  phone: true,
  memo: true,
});

export type Warehouse = z.infer<typeof Warehouse>;
